/* eslint-disable eqeqeq */

import React, { Component } from 'react';
import { Link } from 'react-router';
import Modal from 'react-modal';
import { branch } from 'baobab-react/higher-order';
import renderHTML from 'react-render-html';
import Helmet from 'react-helmet';

import OverviewMedia from './OverviewMedia';
import HatchDetail from './HatchDetail';
import Features from './Features';
import ProductDetailSupport from './ProductDetailSupport';
import ProductSpecifications from './ProductSpecifications';
import Protections from './Protections';
import PlacementImage from './PlacementImage';
import config from '../../config';
import Accessories from './accessories/AccessoriesContainer';


const customStyles = {
	overlay: {
		backgroundColor: 'rgba(0,0,0,0.75)',
		zIndex: 999
	},
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		border: 'none',
		borderRadius: 'none',
		boxShadow: '2px 2px 9px rgba(0,0,0,0.15)',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		maxWidth: 'calc(100% - 40px)'
	}
};

class Overview extends Component {
	constructor(props) {
		super(props);
		this.state = {
			modalOpen: false
		};
	}
	
	openModal() {
		const description = this.props.product.overView.description;
		const modelNumber = this.props.product.overView.modelNumber;
		this.setState({ modalOpen: true });
		
		global.dataLayer.push({
			event: 'Buy Now',
			eventCategory: 'Buy Now',
			eventAction: 'click',
			eventLabel: `${description} - Model ${modelNumber}`
		});
	}

	closeModal() {
		this.setState({ modalOpen: false });
	}

	render() {		
		const productOverview = this.props.product.overView;
		const productUrl = `http://www.sentrysafe.com/product/${productOverview.modelNumber}`;
		const productBVReviews = this.props.product.bvReviews;
		const productBVAggregateRatings = this.props.product.bvAggregateRatings;
		let buyNow;
		let mediaShow;
		let securityProtection;
		let fireProtection;
		let waterProtection;
		let capacity;
		let placementImage;
		let protections;
		let accessories;
		if (productOverview.securityProtection) {
			securityProtection = (
				<li className="protection">
					<img
						className="icon"
						src={ require('../../resources/img/icons/security-icon.png') }
						srcSet={ `${require('../../resources/img/icons/security-icon@2x.png')} 2x` }
						alt="Security Protection"
					/> Security Protection
				</li>
			);
		}

		if (productOverview.fireProtection) {
			fireProtection = (
				<li className="protection">
					<img
						className="icon"
						src={ require('../../resources/img/icons/fire-icon.png') }
						srcSet={ `${require('../../resources/img/icons/fire-icon@2x.png')} 2x` }
						alt="Fire Resistant"
					/> Fire Protection
				</li>
			);
		}

		if (productOverview.waterProtection) {
			waterProtection = (
				<li className="protection">
					<img
						className="icon"
						src={ require('../../resources/img/icons/water-icon.png') }
						srcSet={ `${require('../../resources/img/icons/water-icon@2x.png')} 2x` }
						alt="Water Resistant"
					/> Water Protection
				</li>
			);
		}

		if (productOverview.media !== undefined && productOverview.media.length > 0) {
			mediaShow = <OverviewMedia />;
		}

		if (this.props.standard) {
			capacity = `${productOverview.stdCapacity} cubic ft`;
		} else {
			capacity = `${productOverview.mtcCapacity} liters`;
		}

		if (productOverview.buyNow) {
			buyNow = (
				<div>
					<Link
						className="btn btn-primary"
						onClick={ e => this.openModal(e) }
					>
						Buy Now
					</Link>
					<Modal
						isOpen={ this.state.modalOpen }
						onRequestClose={ () => this.closeModal() }
						style={ customStyles }
						contentLabel="Modal"
					>
						<button
							className="ReactModal__close hatch-modal-close"
							onClick={ () => this.closeModal() }
						>
							<span className="fa fa-times" aria-hidden="true" />
							<span className="assistive-text">close</span>
						</button>
						<HatchDetail standard={ this.props.standard } product={ this.props.product } />
					</Modal>
				</div>
			);
		} else if (productOverview.modelNumber === 'STW123GTC') {
			buyNow = (
				<div>
					<Link
						className="btn btn-primary"
						to="https://store.sentrysafe.com/fire-safes/digital-fire-safe-stw123gtc.html"
						target="_blank"
						rel="noopener"
					>
						Buy Now
					</Link>
				</div>
			);
		}

		if (this.props.product.placementImage !== undefined) {
			placementImage = (
				<PlacementImage placementImage={ this.props.product.placementImage } />
			);
		}

		if (this.props.product.hasProtections) {
			protections = (
				<Protections product={ this.props.product } />
			);
		}

		if (this.props.product.productAccessories !== undefined && this.props.product.productAccessories.length > 0) {
			accessories = (
				<Accessories accessories={ this.props.product.productAccessories } />
			);
		}

		return (
			<section itemScope itemType="http://schema.org/Product">
				<Helmet defer={ false }>
					<script async src={ config.bazaarVoiceScriptUrl } />  
				</Helmet>
				<link itemProp="url" href={ productUrl } />
				<div className="top-section">
					<div className="row">
						<div className="col sm-4 main-features">
							<ul>
								<li className="category-name">
									<h1 itemProp="name">
										<span className="assistive-text">SentrySafe</span>
										<span> { productOverview.description }</span>
										<span className="assistive-text">: Model { productOverview.modelNumber }</span>
									</h1>
								</li>
								<li className="product-rating-summary">
									<div
										data-bv-show="rating_summary"
										data-bv-product-id={ productOverview.modelNumber }
									>
										{ renderHTML(productBVAggregateRatings) }
									</div>
								</li>
								<li className="size-model">
									<span className="size">{ productOverview.size }</span>
									Model <span itemProp="mpn">{ productOverview.modelNumber }</span>
								</li>
								<li>
									Interior Capacity { capacity }
								</li>
								<li>
									Price Range&#58; { this.props.product.priceBucket }
								</li>
								<li className="buy-now">
									{ buyNow }
								</li>
								{ securityProtection }
								{ fireProtection }
								{ waterProtection }
							</ul>
						</div>
						{ mediaShow }
					</div>
				</div>

				{ protections }

				<div className="row overview">
					<div className="col">
						<h2>Overview</h2>
						<p itemProp="description">
							{ renderHTML(productOverview.overView) }
						</p>
					</div>
				</div>

				<Features />

				<ProductSpecifications standard={ this.props.standard } />

				{ placementImage }

				{ accessories }

				<ProductDetailSupport />

				<div data-bv-show="reviews" data-bv-product-id={ productOverview.modelNumber }>
					{ renderHTML(productBVReviews) }
				</div>

				<div data-bv-show="questions" data-bv-product-id={ productOverview.modelNumber } />
			</section>
		);
	}
}

export default branch({
	product: ['product']
}, Overview);


// WEBPACK FOOTER //
// ./src/pages/product/Overview.js